<div class="chart-container">
  @if (!hasData) {
    <div class="empty-state">
      <p>{{ 'DATA_VISUALIZATION.NO_DATA_AVAILABLE' | translate }}</p>
    </div>
  }

  @if (hasData) {
    <div class="chart-wrapper">
      <button class="reset-zoom-btn" (click)="resetZoom()">&#x21BA;</button>
      <canvas #chartCanvas></canvas>
    </div>
  }
</div>
